/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EffectiveDateRangeRequest
 */
export interface EffectiveDateRangeRequest {
    /**
     * 
     * @type {Date}
     * @memberof EffectiveDateRangeRequest
     */
    startDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof EffectiveDateRangeRequest
     */
    endDate?: Date;
}

export function EffectiveDateRangeRequestFromJSON(json: any): EffectiveDateRangeRequest {
    return EffectiveDateRangeRequestFromJSONTyped(json, false);
}

export function EffectiveDateRangeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): EffectiveDateRangeRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'startDate': !exists(json, 'startDate') ? undefined : (new Date(json['startDate'])),
        'endDate': !exists(json, 'endDate') ? undefined : (new Date(json['endDate'])),
    };
}

export function EffectiveDateRangeRequestToJSON(value?: EffectiveDateRangeRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'startDate': value.startDate === undefined ? undefined : (value.startDate.toISOString()),
        'endDate': value.endDate === undefined ? undefined : (value.endDate.toISOString()),
    };
}


